import { useDialog } from '@repo/ui';
import { useAuthContext } from '@repo/user-session';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useRef, useState } from 'react';

import { CI_AUTHENTICATION_ERROR } from '../constants';
import { ciReturnUrlAtom } from '../store';
import { CiPrepareDataResponse } from '../types';

export const usePrepareCiAuthData = (requestType: string, successReturnUrl: string | null) => {
  const { authService } = useAuthContext();
  const { showDialog } = useDialog();
  const setCiReturnUrl = useSetAtom(ciReturnUrlAtom);
  const [prepareData, setPrepareData] = useState<Record<string, string> | null>(null);
  const ciFormRef = useRef<HTMLFormElement>(null);

  const prepareCiAuthenticationData = useCallback(async () => {
    if (!authService || !requestType) return;
    try {
      const response = await authService.getCiPrepare(requestType);

      if (!response.ok) {
        showDialog(CI_AUTHENTICATION_ERROR.prepare_data_failed);
        return;
      }

      const ciPrepareData: CiPrepareDataResponse = await response.json();
      if (!ciPrepareData.result || !ciPrepareData.authInfo) {
        console.error('Invalid CI prepare data:', ciPrepareData.message);
        showDialog(CI_AUTHENTICATION_ERROR.prepare_data_failed);
        return;
      }

      setCiReturnUrl(successReturnUrl);
      setPrepareData({ m: 'service', ...ciPrepareData.authInfo });
    } catch (error) {
      console.error('CI prepare data load failed:', error);
      setCiReturnUrl(null);
      showDialog(CI_AUTHENTICATION_ERROR.prepare_data_failed);
    }
  }, [authService, requestType, setCiReturnUrl, showDialog, successReturnUrl]);

  useEffect(() => {
    if (prepareData && ciFormRef.current) {
      ciFormRef.current.submit();
    }
  }, [prepareData]);

  return { ciFormRef, prepareData, prepareCiAuthenticationData };
};
